package com.fantasytenis.web.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import com.fantasytenis.web.theme.Colors
import kotlinx.browser.window
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.w3c.dom.HTMLInputElement

@Composable
fun TextField(
    value: String,
    onValueChange: (String) -> Unit,
    label: String,
    type: String = "text",
    placeholder: String = "",
    error: String? = null,
    disabled: Boolean = false
) {
    Div({
        style {
            marginBottom(16.px)
        }
    }) {
        // Label
        Label(attrs = {
            style {
                display(DisplayStyle.Block)
                marginBottom(6.px)
                fontSize(14.px)
                fontWeight(500)
                color(Colors.TextPrimary)
            }
        }) {
            Text(label)
        }

        // Input
        val inputId = "input-${label.lowercase().replace(" ", "-")}"

        Input(
            type = when (type) {
                "email" -> InputType.Email
                "password" -> InputType.Password
                "number" -> InputType.Number
                else -> InputType.Text
            }
        ) {
            id(inputId)
            classes("baseline-input")
            if (error != null) {
                classes("baseline-input--error")
            }
            value(value)
            onInput { event ->
                val target = event.target as? HTMLInputElement
                onValueChange(target?.value ?: "")
            }
            onChange { event ->
                val target = event.target as? HTMLInputElement
                onValueChange(target?.value ?: "")
            }
            placeholder(placeholder)
            if (disabled) {
                attr("disabled", "")
            }
            style {
                width(100.percent)
                padding(12.px, 16.px)
                fontSize(16.px)
                borderRadius(8.px)
                border(
                    1.px,
                    LineStyle.Solid,
                    if (error != null) Colors.Error else Colors.Gray300
                )
                backgroundColor(if (disabled) Colors.Gray100 else Colors.White)
                color(if (disabled) Colors.TextDisabled else Colors.TextPrimary)
                property("transition", "border-color 0.2s, box-shadow 0.2s")
            }
        }

        // Check for browser autofill after a short delay
        DisposableEffect(inputId) {
            val timeoutId = window.setTimeout({
                val input = kotlinx.browser.document.getElementById(inputId) as? HTMLInputElement
                input?.value?.let { autofillValue ->
                    if (autofillValue.isNotEmpty() && autofillValue != value) {
                        onValueChange(autofillValue)
                    }
                }
            }, 100)
            onDispose {
                window.clearTimeout(timeoutId)
            }
        }

        // Error Message
        error?.let { errorMessage ->
            Span({
                style {
                    display(DisplayStyle.Block)
                    marginTop(4.px)
                    fontSize(12.px)
                    color(Colors.Error)
                }
            }) {
                Text(errorMessage)
            }
        }
    }
}
